import * as _4 from 'lodash4';
export class APAlternatePlanListItem {
  readonly id: number;
  credit_range: string;
  is_selectable_by_student: boolean;
  is_visible_to_student: boolean;
  is_base_plan: boolean;
  name: string;
  max_credits: number;
  min_credits: number;
  taken_credits: number;

  constructor(alternatePlansListItem: Partial<APAlternatePlanListItem>) {
    _4.merge(this, { is_base_plan: false }, alternatePlansListItem);
  }

  static build(alternatePlansListItem: Partial<APAlternatePlanListItem>): APAlternatePlanListItem {
    return new APAlternatePlanListItem(alternatePlansListItem);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/builders/ap_alternate_plan_list_item_builder.ts